import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
    root_carousel: {
        position: "relative",
        '& .slick-list':{
            '& .slick-track':{
                display: "flex",
                flexFlow: "nowrap",
            },
            '& .slick-slide':{
                width: "312px",
            }
        }
    },
    hover_carousel:{
        '&:hover':{
            '& h4':{
                '& button':{
                    background: "transparent",
                    '& .subtitle':  {
                        color: theme.palette.secondary.main + " !important",
                        position: 'static !important',
                        transition: '0.35s ease-in-out !important',
                        transform: "translate3d(4px, 0px, 0px) !important",
                        visibility: 'visible !important',
                        opacity: "1 !important",
                    },
                    '& .MuiButton-endIcon':{
                        color: theme.palette.secondary.main + " !important",
                        visibility: 'visible !important',
                        opacity: "1 !important",
                        transform: "translate3d(0px, 0px, 0px) scale(1) !important",
                        transition: '0.4s ease-in-out opacity 0.2s linear !important',
                    },
                },  
            },
        },
        [theme.breakpoints.down('xs')]: {
            '& .slick_carousel':{
                '& #root-slik-arrows':{
                    paddingRight: '0 !important'
                }
            },
        },
        "@media (max-width: 768px)": {
            '& h4':{
                '& button':{
                    background: "transparent",
                    '& .subtitle':  {
                        color: theme.palette.secondary.main + " !important",
                        position: 'static !important',
                        transition: '0.35s ease-in-out !important',
                        transform: "translate3d(4px, 0px, 0px) !important",
                        visibility: 'visible !important',
                        opacity: "1 !important",
                        minWidth: "62px",
                    } ,
                    '& .MuiButton-endIcon':{
                        color: theme.palette.secondary.main + " !important",
                        visibility: 'visible !important',
                        opacity: "1 !important",
                        transform: "translate3d(0px, 0px, 0px) scale(1) !important",
                        transition: '0.4s ease-in-out opacity 0.2s linear !important',
                    },
                },  
            },
        }
    },
    title:{
        marginLeft: "59px",
        marginBottom: "16px",
        width: 'fit-content',
        [theme.breakpoints.down('xs')]: {
            marginBottom: '0px !important',
            '&> div':{
                padding: '0px !important'
            }
        },
    },
    card: {
        padding: "12px",
        maxWidth: "fit-content",
    },
    cardActionArea:{
        position: "relative",
        maxWidth: "288px",
    }
}));